module.exports = __webpack_public_path__ + "static/media/sleepyDragonzFrame4.2b3a8a0e.png";